import { FieldFormattingVersion } from '@ardoq/api-types';

export const isRuleVersionApplicable = (
  version: FieldFormattingVersion | undefined
) => !version || version <= FieldFormattingVersion.NEW_CONDITIONAL_FORMATTING;
